/**
 * @generated SignedSource<<cb950e1a5e6b507133ccda65d47b5958>>
 * @relayHash 11fced176023cca9c2b9c16a3368c921
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 00d22c70c75831ad3b429bb0e7cb1d1311492c4ac67e7fb57cc3f435d32208d9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "00d22c70c75831ad3b429bb0e7cb1d1311492c4ac67e7fb57cc3f435d32208d9",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
